function _classPrivateFieldLooseBase(e, t) { if (!{}.hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance"); return e; }
var id = 0;
function _classPrivateFieldLooseKey(e) { return "__private_" + id++ + "_" + e; }
import { debounce, requestIdleCallback, viewTransition } from '@theme/utilities';
import { Component } from '@theme/component';
const OFFSET = 40;

/**
 * A custom element that manages a floating panel.
 */
var _updatePosition = _classPrivateFieldLooseKey("updatePosition");
var _mutationObserver = _classPrivateFieldLooseKey("mutationObserver");
var _resizeListener = _classPrivateFieldLooseKey("resizeListener");
export class FloatingPanelComponent extends Component {
  constructor(...args) {
    super(...args);
    Object.defineProperty(this, _updatePosition, {
      writable: true,
      value: async () => {
        // Wait for any view transitions to finish
        if (viewTransition.current) await viewTransition.current;
        const rect = this.getBoundingClientRect();
        const viewportWidth = window.innerWidth;
        this.style.top = OFFSET + 'px';
        if (rect.right > viewportWidth) {
          const overflowAmount = rect.right - viewportWidth + OFFSET;
          this.style.left = `-${overflowAmount}px`;
        }
        if (rect.left < 0) {
          const overflowAmount = Math.abs(rect.left) + OFFSET;
          this.style.left = `${overflowAmount}px`;
        }
        _classPrivateFieldLooseBase(this, _mutationObserver)[_mutationObserver].takeRecords();
      }
    });
    Object.defineProperty(this, _mutationObserver, {
      writable: true,
      value: new MutationObserver(_classPrivateFieldLooseBase(this, _updatePosition)[_updatePosition])
    });
    Object.defineProperty(this, _resizeListener, {
      writable: true,
      value: debounce(() => {
        const parent = this.closest('details');
        const closeOnResize = this.dataset.closeOnResize === 'true';
        if (parent instanceof HTMLDetailsElement && closeOnResize) {
          parent.open = false;
          parent.removeAttribute('open');
          _classPrivateFieldLooseBase(this, _updatePosition)[_updatePosition]();
        }
      }, 100)
    });
  }
  connectedCallback() {
    super.connectedCallback();
    window.addEventListener('resize', _classPrivateFieldLooseBase(this, _resizeListener)[_resizeListener]);
    requestIdleCallback(() => {
      _classPrivateFieldLooseBase(this, _updatePosition)[_updatePosition]();
      _classPrivateFieldLooseBase(this, _mutationObserver)[_mutationObserver].observe(this, {
        attributes: true
      });
    });
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener('resize', _classPrivateFieldLooseBase(this, _resizeListener)[_resizeListener]);
    _classPrivateFieldLooseBase(this, _mutationObserver)[_mutationObserver].disconnect();
  }
}
if (!customElements.get('floating-panel-component')) {
  customElements.define('floating-panel-component', FloatingPanelComponent);
}
